var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_633_1796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1895 20L15.5701 15.3806M15.5701 15.3806C16.8203 14.1304 17.5227 12.4347 17.5227 10.6666C17.5227 8.89853 16.8203 7.20285 15.5701 5.95261C14.3199 4.70237 12.6242 4 10.8561 4C9.08798 4 7.3923 4.70237 6.14206 5.95261C4.89183 7.20285 4.18945 8.89853 4.18945 10.6666C4.18945 12.4347 4.89183 14.1304 6.14206 15.3806C7.3923 16.6309 9.08798 17.3333 10.8561 17.3333C12.6242 17.3333 14.3199 16.6309 15.5701 15.3806ZM10.8565 8.00052V13.3336M13.5231 10.6671H8.18997",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_633_1796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.03,
    height: 18,
    fill: "white",
    transform: "translate(3.18945 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoView);
export default __webpack_public_path__ + "static/media/ico-view.48c520c322ed8952fcaa6d909a9bf578.svg";
export { ForwardRef as ReactComponent };